// function to determine if an array has any of the elements of another array
export function hasAny(arr, arr2) {
	return arr2?.some((e) => arr?.includes(e));
}